export default "__VITE_ASSET__6f770955__"